export const messages = {
  en: {
    privilege: {
      search: {
        title: 'Search Condition',
        name: 'name',
        domain: 'domain',
        resource: 'resource',
        mId: 'mId',
        description: 'description',
        createTime: 'createTime',
        placeholder: 'Please enter privilege name'
      },
      list: {
        title: 'privilege List'
      },
      dialog: {
        addTitle: 'Add Privilege',
        editTitle: 'Edit Privilege',
        delTitle: 'Delete Privilege',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        pId: 'pId',
        name: 'name',
        domain: 'domain',
        resource: 'resource',
        mId: 'mId',
        description: 'description',
        createTime: 'createTime',
      },
      table: {
        pId: 'pId',
        name: 'name',
        domain: 'domain',
        resource: 'resource',
        mId: 'mId',
        description: 'description',
        createTime: 'createTime',
      },
      validate: {
        pId: 'Please enter pId',
        name: 'Please enter name',
        domain: 'Please enter domain',
        mId: 'Please enter mId',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add Privilege success'
      },
      edit: {
        success: 'Edit Privilege success'
      },
      delete: {
        success: 'Delete Privilege success',
        confirm: 'Are you sure to delete this privilege?'
      },
      fetchError: 'Failed to fetch privilege list'
    }
  },
  zh: {
    privilege: {
      search: {
        title: '查询条件',
        name: '权限名称',
        domain: '商户类型',
        resource: '资源路径',
        mId: '菜单ID',
        description: '权限描述',
        createTime: '创建时间',
        placeholder: '请输入权限名称'
      },
      list: {
        title: '权限列表'
      },
      dialog: {
        addTitle: '添加权限',
        editTitle: '编辑权限',
        delTitle: '删除权限',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        pId: '权限ID',
        name: '权限名称',
        domain: '商户类型',
        resource: '资源路径',
        mId: '菜单ID',
        description: '权限描述',
        createTime: '创建时间',
      },
      table: {
        pId: '权限ID',
        name: '权限名称',
        domain: '商户类型',
        resource: '资源路径',
        mId: '菜单ID',
        description: '权限描述',
        createTime: '创建时间',
      },
      validate: {
        pId: '请输入权限ID',
        name: '请输入权限名称',
        domain: '请输入商户类型',
        mId: '请输入菜单ID',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加权限成功'
      },
      edit: {
        success: '编辑权限成功'
      },
      delete: {
        success: '删除权限成功',
        confirm: '确认删除该权限吗？'
      },
      fetchError: '获取权限列表失败'
    }
  }
}